import axios from '../base/axios';
import API_KEY from './key';

const GET_TVMYSTERY = 'flixfrenzy/redux/GET_TVMYSTERY';

// eslint-disable-next-line default-param-last
const tvMysteryReducer = (state = [], action) => {
  switch (action.type) {
    case GET_TVMYSTERY:
      return action.payload;
    default:
      return state;
  }
};

export const getTvMystery = () => (dispatch) => {
  axios.get(`discover/tv?api_key=${API_KEY}&with_genres=9648`).then((res) => {
    dispatch({
      type: GET_TVMYSTERY,
      payload: res.data,
    });
  });
};

export default tvMysteryReducer;
